import axios from '../../../axiosConfig';

export async function getInventories(config = {}, selectedClient) {
    return await axios.get(`/v1/inventory/all/${selectedClient}`, config);
}

export async function getInventorySimple(selectedClient, config = {}) {
    return await axios.get(`/v1/inventory/${selectedClient}/simple`, config);
}

export async function getInventoryById(id, config = {}) {
    return await axios.get(`/v1/inventory/${id}`, config);
}

export async function getAssetGroupSummaries(config = {}, body) {
    return await axios.post(`/v1/asset/group-summaries`, body, config);
}

export async function getAssetAccountSummaries(config = {}, body) {
    return await axios.post(`/v1/asset/account-summaries`, body, config);
}

export async function createInventory(data, config = {}) {
    return await axios.post(`/v1/inventory`, data, config);
}

export async function updateInventory(data, config = {}) {
    return await axios.put(`/v1/inventory/${data.id}`, data, config);
}

export async function changeInventoryStatus(config = {}, id) {
    return await axios.put(`/v1/inventory/${id}/active-status`, {}, config);
}

export async function deleteInventory(id, config = {}) {
    return await axios.delete(`/v1/inventory/${id}`, config);
}

const functions = { getInventories, getInventorySimple, getInventoryById, getAssetGroupSummaries, getAssetAccountSummaries, createInventory, updateInventory, changeInventoryStatus, deleteInventory }
export default functions
